export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://api.memorydoodle.com/api/v1/";
export const SOCKET_URL =
  process.env.REACT_APP_SOCKET_URL || "https://api.memorydoodle.com";